import type { UserData, UserResponse } from './types';

export const prepareUser = (data: UserResponse): UserData => {
    return {
        ...data,
        id: data.userProfileId,
        primaryEmail: data.email,
    };
};
